/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { TextInput } from '@carbon/react';
import debounce from '../../../../Utilities/debounce/debounce.js';

var _excluded = ["columnKey", "mode", "onChange", "debounceTime"];

/* eslint-disable react/prop-types */

var hoc = function hoc(WrappedComponent) {
  return function (_ref) {
    var columnKey = _ref.columnKey,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'live' : _ref$mode,
      onChange = _ref.onChange,
      _ref$debounceTime = _ref.debounceTime,
      debounceTime = _ref$debounceTime === void 0 ? 300 : _ref$debounceTime,
      passthroughProps = _objectWithoutProperties(_ref, _excluded);
    var delay = mode === 'live' ? debounceTime : 0;
    var augmentedOnChange = debounce(function (value) {
      onChange({
        value: value,
        columnKey: columnKey,
        mode: mode
      });
    }, delay);
    return /*#__PURE__*/React.createElement(WrappedComponent
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, passthroughProps, {
      onChange: function onChange(e) {
        return augmentedOnChange(e.target.value);
      }
    }));
  };
};
var TableToolbarTextInput = hoc(TextInput);
var TableToolbarTextInput$1 = TableToolbarTextInput;

export { TableToolbarTextInput$1 as default };
